/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PromotionCronDto } from './promotionCronDto';
import { NotificationDto } from './notificationDto';
import { AwardStrategyDto } from './awardStrategyDto';
import { ConditionDto } from './conditionDto';
import { PlaceInformationDto } from './placeInformationDto';
import { PromotionCheckerDto } from './promotionCheckerDto';
import { ClientLoyaltyProgramDto } from './clientLoyaltyProgramDto';


export interface PromotionDto { 
    id?: number;
    name?: string;
    status?: PromotionDto.StatusEnum;
    cron?: PromotionCronDto;
    image?: string;
    description?: string;
    repeat?: boolean;
    showOnHome?: boolean;
    rules?: string;
    validFrom?: string;
    validUntil?: string;
    rewardStrategy?: string;
    rewardValue?: string;
    awardStrategies?: Array<AwardStrategyDto>;
    loyaltyProgram?: ClientLoyaltyProgramDto;
    notification?: NotificationDto;
    check?: PromotionCheckerDto;
    conditions?: Array<ConditionDto>;
    targetPlaces?: Array<PlaceInformationDto>;
}
export namespace PromotionDto {
    export type StatusEnum = 'ACTIVE' | 'INACTIVE';
    export const StatusEnum = {
        Active: 'ACTIVE' as StatusEnum,
        Inactive: 'INACTIVE' as StatusEnum
    };
}


